import React, {useMemo, useState} from 'react';

import {Button, Grid, Icon} from '@material-ui/core';
import {Card, Form, Col, InputGroup} from 'react-bootstrap';
import {useStyles} from "./styles";
import {format} from "date-fns";

import {useLinksUIContext} from "../../../contexts/LinksUIContext";
import {salesStatusOptions} from "../LinksTable/ui.helpers";

const toDay = format(new Date(), 'yyyy-MM-dd');

export function LinksFilter() {
  const classes = useStyles();
  const context = useLinksUIContext();

  const {queryParams, setQueryParams} = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
  }), [context]);

  const [filter, setFilter] = useState(queryParams.filter);

  const handleChangeFilter = (key) => (e) => {
    setFilter({...filter, [key]: e.target.value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const _filter = {
      ...filter,
      startDt: filter.startDt ? format(new Date(filter.startDt), 'yyyyMMdd') : '',
      endDt: filter.endDt ? format(new Date(filter.endDt), 'yyyyMMdd') : '',
    }
    setQueryParams({...queryParams, filter: _filter});
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Card>
        <Card.Body>
          <Card.Title as="h5" className="mb-5">
            <Icon color="secondary" className="mr-2 align-middle">search</Icon>
            검색
          </Card.Title>
          <hr className="mb-10" />
          <Grid container>
            <Grid item xs={6} md={3}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col} controlId="saleNo">
                  <Form.Label>링크코드</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="링크코드를 입력하세요."
                    value={filter.saleNo}
                    onChange={handleChangeFilter('saleNo')}
                  />
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={12} lg={3}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col} controlId="saleSttsCd">
                  <Form.Label>판매 상태</Form.Label>
                  <Form.Control
                    as="select"
                    value={filter.provStatus}
                    onChange={handleChangeFilter('saleSttsCd')}
                  >
                    <option value="">선택안함</option>
                    {salesStatusOptions.map(opt => (
                      <option key={opt.key} value={opt.key}>{opt.label}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col} controlId="linkNm">
                  <Form.Label>링크 이름</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="링크 이름을 입력하세요."
                    value={filter.linkNm}
                    onChange={handleChangeFilter('linkNm')}
                  />
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col} controlId="goodsNm">
                  <Form.Label>상품 이름</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="링크 이름을 입력하세요."
                    value={filter.goodsNm}
                    onChange={handleChangeFilter('goodsNm')}
                  />
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={12} md={6}>
              <Form.Row className={classes.fullWidth}>
                <Form.Group as={Col}>
                  <Form.Label>판매 등록일자</Form.Label>
                  <InputGroup>
                    <Form.Control
                      id="startDt"
                      type="date"
                      max={filter.endDt}
                      value={filter.startDt}
                      placeholder="yyyy. mm. dd"
                      aria-describedby="basic-addon1"
                      onChange={handleChangeFilter('startDt')}
                    />
                    <InputGroup.Prepend>
                      <InputGroup.Text>~</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      id="endDt"
                      type="date"
                      min={filter.startDt}
                      max={toDay}
                      value={filter.endDt}
                      placeholder="yyyy. mm. dd"
                      aria-describedby="basic-addon2"
                      onChange={handleChangeFilter('endDt')}
                    />
                  </InputGroup>
                </Form.Group>
              </Form.Row>
            </Grid>

            <Grid item xs={12} className="text-right pl-3 pr-3">
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                className="w-130px"
              >
                검색
              </Button>
            </Grid>
          </Grid>
        </Card.Body>
      </Card>
    </Form>
  );
}
